module.exports = __webpack_public_path__ + "static/media/1019061.3e6505a1.jpg";